<template>
  <div>
    <!-- 举报信息 -->
    <commonReportInfo :data="getByIdFullData" @firstTrialInfo="firstTrialInfo"></commonReportInfo>
    <!-- 响应信息 -->
    <div>
      <!-- 待初审 -->
      <div v-if="getByIdFullData.status==0">
        <div class="drawer-subtitle_common">
          <span>初审信息</span>
        </div>
        <el-card class="margin_top_bottom20">
          <el-form :label-width="labelWidth">
            <el-form-item label="初审结果：">
              <el-radio
                label="1"
                border
                size="small"
                class="no_circle_radio"
                v-model="firsttrial.status"
              >接受举报</el-radio>
              <el-radio
                label="10"
                border
                size="small"
                class="no_circle_radio"
                v-model="firsttrial.status"
              >驳回举报</el-radio>
            </el-form-item>
            <el-form-item label="驳回说明：" v-if="firsttrial.status==10">
              <el-input
                type="textarea"
                placeholder="请输入驳回理由，请保持在200字以内。"
                class="common_textarea"
                maxlength="200"
                v-model="firsttrial.reportexplain"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
      <div v-for="(item,index) in getByIdFullData.flowList" :key="'k'+index">
        <!-- 未响应 -->
        <div v-if="item.status==6&&item.lable">
          <div class="drawer-subtitle_common">
            <span>{{item.lable}}</span>
          </div>
          <el-card class="margin_top_bottom20">
            <el-form :label-width="labelWidth">
              <el-form-item label="响应方式：">未响应</el-form-item>
            </el-form>
          </el-card>
        </div>
        <!-- 申诉评定信息 -->
        <div v-if="item.status==13">
          <div class="drawer-subtitle_common">
            <span>申诉评定信息</span>
          </div>
          <el-card class="margin_top_bottom20">
            <el-form :label-width="labelWidth">
              <el-form-item label="申诉评定：">申诉不合理</el-form-item>
              <el-form-item label="评定说明：">{{item.reportexplain}}</el-form-item>
            </el-form>
          </el-card>
        </div>
        <!-- 店铺已整改-待复查 -->
        <div v-if="item.status==2&&item.lable">
          <div class="drawer-subtitle_common">
            <span>{{item.lable}}</span>
          </div>
          <el-card class="margin_top_bottom20">
            <el-form :label-width="labelWidth">
              <el-form-item label="响应方式：">{{item.resulttype}}</el-form-item>
            </el-form>
          </el-card>
        </div>
        <!-- 店铺整改合格-待处理||店铺已申诉-待处理 -->
        <div v-if="(item.status==3||item.status==4||item.status==5||item.status==8)&&item.lable">
          <div class="drawer-subtitle_common">
            <span>{{item.lable}}</span>
          </div>
          <el-card class="margin_top_bottom20">
            <el-form :label-width="labelWidth">
              <el-form-item
                v-if="item.status!==8"
                :label="item.status==5?'响应方式：':'复查结果：'"
              >{{item.status==3?'店铺整改合格':item.status==4?'店铺整改不合格':'店铺已申诉'}}</el-form-item>
              <el-form-item :label="item.status==5?'申诉截图：':item.status==8?'二次申诉截图：':'复查截图：'">
                <viewer :images="item.reportpic" v-if="item.reportpic">
                  <img
                    v-for="(item,index) in item.reportpic"
                    :src="item"
                    alt
                    :key="index"
                    style="width:100px;height:100px;margin-right:10px"
                  />
                </viewer>
              </el-form-item>
              <el-form-item
                :label="item.status==5?'申诉理由：':item.status==8?'二次申诉理由：':'复查说明：'"
              >{{item.reportexplain}}</el-form-item>
              <el-form-item
                label="复查人："
                v-if="item.status!==5&&item.status!==8"
              >{{item.flowusername}}</el-form-item>
            </el-form>
          </el-card>
        </div>
        <div v-if="item.status==10">
          <div class="drawer-subtitle_common">
            <span>初审信息</span>
          </div>
          <el-card class="margin_top_bottom20">
            <el-form :label-width="labelWidth">
              <el-form-item label="初审结果：">驳回举报</el-form-item>
              <el-form-item label="驳回说明：">{{item.reportexplain}}</el-form-item>
              <el-form-item label="初审人：">{{item.flowusername}}</el-form-item>
              <el-form-item label="初审时间：">{{item.createtime |fullTime}}</el-form-item>
            </el-form>
          </el-card>
        </div>
      </div>
      <!-- 操作页面 -->
      <div
        v-if="getByIdFullData.status===2&&(logintype=='KEFU'||logintype=='HCM'||logintype=='HCMSUB')"
      >
        <response :status="getByIdFullData.status" ref="rectificationChild"></response>
      </div>
      <!-- 申诉评定不合格 -->
      <div v-if="getByIdFullData.status==13&&(logintype=='SHOP'||logintype=='DEALER')">
        <div class="drawer-subtitle_common">
          <span>二次响应信息</span>
        </div>
        <el-card class="margin_top_bottom20">
          <el-form :label-width="labelWidth">
            <el-form-item label="响应方式：" required>
              <div>
                <el-radio
                  label="2"
                  border
                  size="small"
                  class="no_circle_radio"
                  v-model="respontrial.val"
                >我已整改</el-radio>
              </div>
            </el-form-item>
          </el-form>
        </el-card>
      </div>
      <!-- 待店铺响应 -->
      <div v-if="getByIdFullData.status==1&&(logintype==='SHOP'||logintype==='DEALER')">
        <div class="drawer-subtitle_common">
          <span>响应信息</span>
        </div>
        <el-card class="margin_top_bottom20">
          <el-form :label-width="labelWidth">
            <el-form-item label="响应方式：" required>
              <div v-show="logintype=='SHOP'||logintype=='DEALER'">
                <el-radio
                  label="2"
                  border
                  size="small"
                  class="no_circle_radio"
                  v-model="respontrial.val"
                >我已整改</el-radio>
                <el-radio
                  label="5"
                  border
                  size="small"
                  class="no_circle_radio"
                  v-model="respontrial.val"
                >我要申诉</el-radio>
              </div>
            </el-form-item>
            <el-form-item :required="true" label="申诉截图" v-show="respontrial.val==5">
              <uploadPic ref="uploadPics"></uploadPic>
            </el-form-item>
            <el-form-item :required="true" label="申诉理由" v-show="respontrial.val==5">
              <el-input
                type="textarea"
                placeholder="请输入申诉理由，请保持在200字以内。"
                class="common_textarea"
                maxlength="200"
                v-model="respontrial.reportexplain"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <!-- 申诉评定信息 -->
      <div v-if="getByIdFullData.status==5&&(logintype!=='SHOP'&&logintype!=='DEALER')">
        <div class="drawer-subtitle_common">
          <span>申诉评定信息</span>
        </div>
        <el-card class="margin_top_bottom20">
          <el-form :label-width="labelWidth">
            <el-form-item label="申诉评定：" required>
              <div>
                <el-radio
                  label="7"
                  border
                  size="small"
                  class="no_circle_radio"
                  v-model="evaluate.val"
                >申诉合理</el-radio>
                <el-radio
                  label="13"
                  border
                  size="small"
                  class="no_circle_radio"
                  v-model="evaluate.val"
                >申诉不合理</el-radio>
              </div>
            </el-form-item>
            <el-form-item label="申诉评定截图">
              <uploadPic ref="uploadPics2"></uploadPic>
            </el-form-item>
            <el-form-item label="评定说明：">
              <el-input
                type="textarea"
                placeholder="请输入评定说明，请保持在200字以内。"
                class="common_textarea"
                maxlength="200"
                v-model="evaluate.reportexplain"
              ></el-input>
            </el-form-item>
          </el-form>
        </el-card>
      </div>

      <!-- 申诉评定信息 -->
      <div v-if="ifEvaluate">
        <div class="drawer-subtitle_common">
          <span>申诉评定信息</span>
        </div>
        <el-card class="margin_top_bottom20">
          <el-form :label-width="labelWidth">
            <el-form-item label="申诉评定：">申诉合理</el-form-item>
            <el-form-item label="评定说明：">{{getByIdFullData.reportexplain}}</el-form-item>
          </el-form>
        </el-card>
      </div>
      <!-- 处理信息 -->
      <dealResultview
        @showDealBtn="showDealBtn"
        ref="refResultView"
        v-show="dealBtnShow()"
        @scrollBottom="scrollBottom"
        @showShopDealBtn="showShopDealBtn"
      ></dealResultview>

      <div class="flex_end margin_top20" v-if="HCMbtnOperate">
        <el-button type="confire_btn" size="small" @click="updateStatus" :disabled="btndisabled">确定</el-button>
        <el-button type="cancel_blue" size="small" @click="closeInfo">取消</el-button>
      </div>
      <!-- 店铺 -->
      <div class="flex_end margin_top20" v-if="shopOperate">
        <el-button type="confire_btn" size="small" @click="updateStatus" :disabled="btndisabled">确定</el-button>
        <el-button type="cancel_blue" size="small" @click="closeInfo">取消</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import commonReportInfo from "@/views/CreditScore/common/commonReportInfo";
import uploadPic from "@/views/CreditScore/common/uploadPic";
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { getLoginType } from "@/libs/until";
import response from "./response";
import dealResultview from "./dealResult";
import creditReport from "@/mixins/creditReport.js";
import { ifEvaluate} from "@/libs";

export default {
  props: {},
  data() {
    return {
      deal: {
        reportexplain: "",
      },
      labelWidth: "130px",
      logintype: getLoginType(),
      responeShop: "",
      firsttrial: {
        status: "",
        reportexplain: "",
      },
      btndisabled: false,
      respontrial: {
        reportexplain: "",
        responeShop: "",
      },
      evaluate: {
        val: "",
        reportexplain: "",
        reportpic: '',
      },
      HCMbtnOperate: false,
      shopOperate: false,
    };
  },
  components: { commonReportInfo, response, dealResultview, uploadPic },
  mixins: [creditReport],
  computed: {
    ifEvaluate() {
      return ifEvaluate(this.getByIdFullData.flowList)
    },
    ...mapState({
      creditShopid: (state) => state.creditScore.creditShopid,
    }),
    ...mapGetters(["getByIdFullData"]),
  },
  created() {
    this.firstTrialInfo();
    this.$nextTick(() => {
      this.$refs.refResultView.toResult();
      this.btnShow();
      this.shopBtn();
    });
  },
  methods: {
    ...mapActions(["getById"]),
    scrollBottom() {
      this.$emit("scrollBottom");
    },
    showShopDealBtn() {
      this.shopOperate = true;
    },
    closeInfo() {
      this.$emit("closeDraw");
    },
    showDealBtn() {
      this.HCMbtnOperate = true;
    },
    dealBtnShow() {
      let status = this.getByIdFullData.status;
      let logintype = this.logintype;
      if (
        status == 9 ||
        (status == 3 && logintype !== "SHOP" && logintype !== "DEALER") ||
        (status == 4 && logintype !== "SHOP" && logintype !== "DEALER") ||
        (status == 6 && logintype !== "SHOP" && logintype !== "DEALER") ||
        status == 7 ||
        (status == 8 && logintype !== "SHOP" && logintype !== "DEALER")
      ) {
        return true;
      } else {
        false;
      }
    },
    btnShow() {
      let status = this.getByIdFullData.status;
      let arrStatus = [0, 2, 3, 4, 5, 6, 8];
      if (arrStatus.indexOf(status) !== -1) {
        if (
          this.logintype === "KEFU" ||
          this.logintype == "HCM" ||
          this.logintype == "HCMSUB"
        ) {
          this.HCMbtnOperate = true;
        } else {
          this.HCMbtnOperate = false;
        }
      } else {
        this.HCMbtnOperate = false;
      }
    },
    shopBtn() {
      let logintype = this.logintype;
      let status = this.getByIdFullData.status;
      if (
        (status == 1 || status == 13) &&
        (logintype === "SHOP" || logintype === "DEALER")
      ) {
        this.shopOperate = true;
      } else {
        this.shopOperate = false;
      }
    },
    firstTrialInfo(shopid) {
      //判断是否可以初审
      let data = this.getByIdFullData;
      if (data.status === 0) {
        if (
          data.shopname &&
          data.productinfoid &&
          data.reporturl &&
          data.platform_code
        ) {
          this.btndisabled = false;
        } else {
          this.btndisabled = true;
          this.shopid = shopid;
        }
      } else {
        this.btndisabled = false;
      }
    },
    async updateStatus() {
      //修改处理结果的时候走updateHandle 除了修改结果都要走updateStatus
      let status = this.getByIdFullData.status;
      let result;
      this.btndisabled = true;
      if (status == 0) {
        result = await this.firstTrial();
        //初审中
      }
      if (status == 1 || status == 13) {
        //店铺申诉/整改
        result = await this.shopResponeTrial();
      }
      if (status == 2) {
        // 店铺已整改-待复查
        result = await this.rectificationHttp();
      }
      if (status == 3 || status == 4) {
        // 店铺整改合格-待处理  /整改不合格
        result = await this.kefuAgain(7);
      }
      if (status == 5) {
        // 店铺已申诉
        result = await this.appealFun();
      }
      if (status == 6) {
        // 店铺未响应
        result = await this.kefuAgain(9);
      }
      if (status == 7) {
        // 店铺二次申诉
        if (this.HCMbtnOperate) {
          //品牌方客服
          result = await this.editUpdateResult();
        } else if (this.shopOperate) {
          //店铺经销商
          result = await this.shopAgain();
        }
      }
      if (status == 8) {
        // 二次申诉处理（客服）
        result = await this.kefuAgain(9);
      }
      if (status == 9) {
        //编辑处理结果
        result = await this.editUpdateResult();
      }
      if (result !== false) {
        this.$emit("loadPage");
        this.parentTable();
      }
      this.btndisabled = false;
    },
    async appealFun() {
      if (Number(this.evaluate.val) === 13 || Number(this.evaluate.val) === 7) {
        let data = {
          reportexplain: this.evaluate.reportexplain,
          status: Number(this.evaluate.val),
        };
        if (this.$refs.uploadPics2.uploadPicHtpp.length != 0) {
          data.reportpic = String(this.$refs.uploadPics2.uploadPicHtpp);
        }
        await this.updateStatusHttp(data);
      } else {
        let data = {
          reportexplain: this.evaluate.reportexplain,
          result: "申诉内容合理，本链接不存在违规情况",
          decisions: "申诉内容合理，系统自动处理",
        };
        await this.handleHttp(data);
      }
    },
    async editUpdateResult(hint) {
      this.btndisabled = true;
      let data = {
        id: this.getByIdFullData.id,
        ...this.$refs.refResultView.deal,
      };
      await fetch({
        url: "hcm/hcmReport/updateHandle",
        method: "post",
        data: data,
      })
        .then((res) => {
          if (!hint) {
            this.$message.success("成功");
          }
          this.parentTable();
          this.$emit("loadPage");
          this.loadPageData();
        })
        .catch(() => {
          this.btndisabled = true;
        });
    },
    parentTable() {
      this.btndisabled = false;
      this.$emit("closeDraw");
      //调用父方法 刷新列表
      this.$emit("getCountByBmc");
      this.$emit("getSatetCountref");
      this.$emit("getSatetCount");
      this.$emit("searchCountChange"); //我的违规记录状态数量
    },
    async firstTrial() {
      let data = {};
      if (!this.firsttrial.status) {
        this.$message({ type: "warning", message: "请选择初审结果" });
        return false;
      }
      //客服初审中
      if (this.firsttrial.status == 10) {
        //驳回举报
        if (!this.firsttrial.reportexplain.replace(/\s+/g, "")) {
          this.$message({ type: "warning", message: "请输入驳回说明" });
          return false;
        }
        data = { ...this.firsttrial };
      } else {
        data.status = 1; //接收
      }
      await this.updateStatusHttp(data);
    },
    async shopResponeTrial() {
      ///店铺申诉/整改
      let data = {};
      if (!this.respontrial.val) {
        this.$message({ type: "warning", message: "请选择响应方式" });
        return false;
      }
      if (this.respontrial.val === "5") {
        //我要申诉
        if (!this.respontrial.reportexplain.replace(/\s+/g, "")) {
          this.$message({ type: "warning", message: "请输入申诉理由" });
          return false;
        }
        if (this.$refs.uploadPics.uploadPicHtpp.length == 0) {
          this.$message({ type: "warning", message: "请上传申诉截图" });
          return false;
        }
        data.reportexplain = this.respontrial.reportexplain;
        data.reportpic = String(this.$refs.uploadPics.uploadPicHtpp);
      }
      data.status = this.respontrial.val;
      await this.updateStatusHttp(data);
    },
    async updateStatusHttp(data) {
      data.reportid = this.getByIdFullData.id;
      await fetch({
        url: "hcm/hcmReport/updateStatus",
        method: "post",
        data,
      })
        .then((res) => {
          if (res.status == "10000") {
            this.$message({ type: "success", message: "成功" });
          } else {
            this.$message({ type: "error", message: res.message });
          }
        })
        .catch(() => {
          this.btndisabled = false;
        });
    },
    async rectificationHttp() {
      //整改不合格/合格
      let {status}=this.$refs.rectificationChild.rectification
      if (!status) {
        this.$message({ type: "warning", message: "请选择响应方式" });
        return false;
      }
      await this.updateStatusHttp(this.$refs.rectificationChild.rectification); //合格不合格
      // if (Number(status) === 3) {
      //   await this.handleHttp({
      //     result: "在规定时间内整改合格",
      //     decisions: "在规定时间内整改合格，系统自动处理",
      //   });
      // }
    },
    async shopAgain() {
      //店铺二次申诉
      let data = { ...this.$refs.refResultView.twice, status: 8 };
      if (!data.reportexplain.replace(/\s+/g, "")) {
        this.$message({ type: "warning", message: "请输入二次申诉理由" });
        return false;
      }
      if (!data.reportpic) {
        this.$message({ type: "warning", message: "请上传二次申诉截图" });
        return false;
      }
      await this.updateStatusHttp(data);
    },
    async kefuAgain(status, toNext) {
      let data = {
        status: status,
        ...this.$refs.refResultView.deal,
      };
      let { result } = this.$refs.refResultView.deal;
      if (!result) {
        this.$message({ type: "warning", message: "请选择处理结果" });
        return false;
      }
      console.log(1231231)
      await this.handleHttp(data); //handle接口不需要调updateStatusHttp
    },
    cancleDualog() {
      this.$emit("getCountByBmc");
      this.$emit("getSatetCountref");
      this.ifshow = false;
      this.cleardata();
      this.btndisabled = false;
      this.close();
    },
    async handleHttp(data) {
      data.ids = this.getByIdFullData.id;
      data.reportid = this.getByIdFullData.reportid
      await fetch({ url: "hcm/hcmReport/handle", method: "post", data: data })
        .then((res) => {
          if (res.status == "10000") {
            this.$emit("loadPage");
            this.parentTable();
          } else {
            this.$message({ type: "warning", message: res.message });
          }
          this.btndisabled = false;
        })
        .catch(() => {
          this.btndisabled = false;
        });
    },
  },
};
</script>
<style lang="scss">
.el-drawer-deal2 {
  .drawer-subtitle_common {
    margin: 0;
  }
}
</style>
